module.exports = __webpack_public_path__ + "img/CellCycle-CRC_10X_WTA.52f6e4e7.png";